import React, { useState, useEffect } from 'react';

export default function App() {
  const [isAppReady, setIsAppReady] = useState(false);
  const [currentUser, setCurrentUser] = useState(null);
  
  const [documents, setDocuments] = useState([]);
  const [users, setUsers] = useState([]);
  
  const [sidebarMode, setSidebarMode] = useState('main'); 
  const [activeTab, setActiveTab] = useState('welcome');
  const [loading, setLoading] = useState(false);
  const [saving, setSaving] = useState(false);
  
  const getToday = () => new Date().toISOString().split('T')[0];

  const [showAddForm, setShowAddForm] = useState(false);
  const [editingRow, setEditingRow] = useState(null);
  const [formData, setFormData] = useState({ choso: '', vaoso: '', ngay: getToday(), noiras: '', noinhan: '', noiluu: '', noidung: '', ghichu: '' });
  
  // NÂNG CẤP: Chuyển đổi trạng thái lưu trữ thành mảng (Array) để chứa nhiều file cũ
  const [retainedFiles, setRetainedFiles] = useState({ goc: [], word: [], pdfUn: [] });

  const [showUserForm, setShowUserForm] = useState(false);
  const [editingUser, setEditingUser] = useState(null);
  const [userFormData, setUserFormData] = useState({ username: '', password: '', role: 'user', permissions: [] });

  const [searchTerm, setSearchTerm] = useState('');

  // LINK WEB APP
  const GOOGLE_APP_URL = 'https://script.google.com/macros/s/AKfycby1u38OY0ha15TdSBh3smxuCrlWYqN-dCzPU6pqrAegTzMgOue5AMWWeG7WI2HfTupv/exec';

  const subMenus = [
    { id: 'cv_di', name: '1. Công Văn Đi' }, { id: 'cv_den', name: '2. Công Văn Đến' }, 
    { id: '2', name: '3. Thông Báo' }, { id: '3', name: '4. Kế Hoạch' }, 
    { id: '4', name: '5. Quyết Định' }, { id: '5', name: '6. Tờ Trình' }, 
    { id: '6', name: '7. Khoá Học' }, { id: '7', name: '8. Khen Thưởng' }, 
    { id: '8', name: '9. Báo Cáo' }, { id: '9', name: '10. Đề Nghị' }, { id: '10', name: '11. Thư Mời' }
  ];

  const allModules = subMenus.flatMap(m => [
    { id: `vtf_${m.id}`, name: `VTF - ${m.name}` },
    { id: `htf_${m.id}`, name: `HTF - ${m.name}` }
  ]);

  useEffect(() => { loadData(); }, []);

  const loadData = async () => {
    setLoading(true);
    try {
      const res = await fetch(`${GOOGLE_APP_URL}?t=${Date.now()}`);
      const json = await res.json();
      
      if (json.error) {
        console.error("Lỗi từ Google Script:", json.error);
        alert("Lỗi từ máy chủ: " + json.error);
      } else {
        setDocuments(json.documents.map((r, i) => [
          i + 1, r.choso, r.vaoso, r.ngay, r.noidung, r.noiras, r.noinhan, r.noiluu, 
          r.filegoc, r.fileword, r.filechuadau, r.ghichu, r.category, r.rowIndex 
        ]));
        setUsers(json.users || []);
      }
    } catch (e) { 
      console.error("Lỗi tải dữ liệu:", e); 
    } finally {
      setIsAppReady(true);
      setLoading(false);
    }
  };

  const handleLogin = (e) => {
    e.preventDefault();
    const uname = e.target.username.value.trim();
    const upass = e.target.password.value.trim();

    if (users.length === 0) {
      alert('Hệ thống chưa tải được danh sách tài khoản. Vui lòng kiểm tra lại file Excel!');
      return;
    }

    const foundUser = users.find(u => String(u.username).trim() === uname && String(u.password).trim() === upass);
    if (foundUser) {
      setCurrentUser(foundUser);
      setSidebarMode('main');
      setActiveTab('welcome'); 
    } else alert('Sai tài khoản hoặc mật khẩu!');
  };

  // NÂNG CẤP: Hàm xử lý MẢNG file thay vì 1 file đơn lẻ
  const filesToBase64 = async (fileList) => {
    if (!fileList || fileList.length === 0) return [];
    const filesArray = Array.from(fileList);
    const promises = filesArray.map(file => new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = () => resolve({ name: file.name, mimeType: file.type, base64: reader.result.split(',')[1] });
      reader.onerror = error => reject(error);
    }));
    return Promise.all(promises);
  };

  // NÂNG CẤP: Chuyển dữ liệu file về định dạng chuẩn bất kể dữ liệu cũ hay mới
  const parseFiles = (fileData) => {
    if (Array.isArray(fileData)) return fileData;
    if (fileData && fileData.name) return [fileData];
    return [];
  };

  const handleSaveDoc = async () => {
    const fileGoc = document.getElementById('add_file_goc')?.files;
    const fileWord = document.getElementById('add_file_word')?.files;
    const filePDFUn = document.getElementById('add_file_pdf_un')?.files;

    const MAX_SIZE = 20 * 1024 * 1024;
    const checkSize = (files) => files && Array.from(files).some(f => f.size > MAX_SIZE);
    if (checkSize(fileGoc) || checkSize(fileWord) || checkSize(filePDFUn)) {
      alert("Cảnh báo: Có file vượt quá 20MB! Vui lòng chọn tệp nhỏ hơn để hệ thống không bị treo.");
      return;
    }

    setSaving(true);
    setShowAddForm(false); 

    try {
      const payload = { action: editingRow ? 'edit' : 'add', rowIndex: editingRow ? editingRow[13] : null, category: activeTab, ...formData };
      
      // Định dạng mảng file cũ thành chuỗi có dấu phân cách đặc biệt "|||" và ";;;"
      const formatOldFiles = (fArray) => fArray.map(f => `${f.name}|||${f.url}`).join(';;;');

      if (fileGoc && fileGoc.length > 0) payload.filegoc = await filesToBase64(fileGoc); 
      payload.filegoc_old = formatOldFiles(retainedFiles.goc);
      
      if (fileWord && fileWord.length > 0) payload.fileword = await filesToBase64(fileWord); 
      payload.fileword_old = formatOldFiles(retainedFiles.word);
      
      if (filePDFUn && filePDFUn.length > 0) payload.filechuadau = await filesToBase64(filePDFUn); 
      payload.filechuadau_old = formatOldFiles(retainedFiles.pdfUn);
      
      await fetch(GOOGLE_APP_URL, { method: 'POST', mode: 'no-cors', headers: { 'Content-Type': 'text/plain;charset=utf-8' }, body: JSON.stringify(payload) });
      
      setTimeout(() => { setEditingRow(null); loadData(); setSaving(false); }, 1500); 
    } catch (e) { 
      alert("Lỗi mạng! Quá trình lưu file bị gián đoạn."); 
      setSaving(false); 
    }
  };

  const handleDeleteDoc = async (row) => {
    if (!window.confirm("Bạn có chắc chắn muốn XÓA văn bản này không? Hành động này không thể hoàn tác, và file trên Drive cũng sẽ bị xóa bỏ.")) return;
    setLoading(true);
    
    try {
      // NÂNG CẤP: Gom toàn bộ link của văn bản này để gửi yêu cầu xóa lên Drive
      const allFileUrls = [
        ...parseFiles(row[8]),
        ...parseFiles(row[9]),
        ...parseFiles(row[10])
      ].map(f => f.url).filter(Boolean);

      const payload = { 
        action: 'delete', 
        category: row[12], 
        rowIndex: row[13],
        filesToDelete: allFileUrls // Biến mới truyền xuống GAS
      };

      await fetch(GOOGLE_APP_URL, { method: 'POST', mode: 'no-cors', headers: { 'Content-Type': 'text/plain;charset=utf-8' }, body: JSON.stringify(payload) });
      setTimeout(() => loadData(), 1500);
    } catch(e) { 
      alert("Xoá thất bại"); 
      setLoading(false); 
    }
  };

  const handleSaveUser = async () => {
    setSaving(true);
    try {
      const payload = { action: editingUser ? 'editUser' : 'addUser', rowIndex: editingUser ? editingUser.rowIndex : null, ...userFormData };
      setShowUserForm(false);
      await fetch(GOOGLE_APP_URL, { method: 'POST', mode: 'no-cors', headers: { 'Content-Type': 'text/plain;charset=utf-8' }, body: JSON.stringify(payload) });
      setTimeout(() => { setEditingUser(null); loadData(); setSaving(false); }, 1500);
    } catch(e) { alert("Lỗi lưu người dùng!"); setSaving(false); }
  };

  const handleDeleteUser = async (u) => {
    if (!window.confirm(`Bạn có chắc chắn XÓA tài khoản [${u.username}] không?`)) return;
    setLoading(true);
    try {
      await fetch(GOOGLE_APP_URL, { method: 'POST', mode: 'no-cors', headers: { 'Content-Type': 'text/plain;charset=utf-8' }, body: JSON.stringify({ action: 'deleteUser', rowIndex: u.rowIndex }) });
      setTimeout(() => loadData(), 1000);
    } catch(e) { alert("Xóa thất bại"); setLoading(false); }
  };

  const getDirectUrl = (url) => {
    if (!url) return "";
    const match = url.match(/\/d\/([a-zA-Z0-9-_]+)/);
    return match ? `https://drive.google.com/uc?export=download&id=${match[1]}` : url;
  };
  
  // NÂNG CẤP: Render mảng nhiều file theo dạng danh sách dọc trong 1 ô
  const renderFile = (fData, isPdf) => {
    const files = parseFiles(fData);
    if (files.length === 0) return <span className="text-muted">-</span>;

    return (
      <div className="d-flex flex-column gap-1 align-items-center">
        {files.map((f, idx) => (
          <div key={idx} className={`d-flex flex-column align-items-center ${idx !== files.length - 1 ? 'border-bottom pb-1 mb-1' : ''}`}>
            <span className="text-dark mb-1 text-truncate" style={{ maxWidth: '85px', fontSize: '0.7rem', fontWeight: '500' }} title={f.name}>{f.name}</span>
            {f.url ? (
              <div className="d-flex gap-1 mt-1">
                {isPdf && <a href={f.url} target="_blank" rel="noreferrer" className="btn btn-outline-info btn-sm py-0 px-1" style={{ fontSize: '0.65rem', fontWeight: 'bold' }}>Xem</a>}
                <a href={getDirectUrl(f.url)} download={f.name} target="_blank" rel="noreferrer" className="btn btn-outline-success btn-sm py-0 px-1" style={{ fontSize: '0.65rem', fontWeight: 'bold' }}>Tải</a>
              </div>
            ) : <span className="badge bg-secondary text-white px-1 py-1" style={{fontSize: '0.65rem'}}>Mất link</span>}
          </div>
        ))}
      </div>
    );
  };

  // PHÂN QUYỀN
  const canModify = currentUser?.role === 'admin' || (Array.isArray(currentUser?.permissions) && currentUser?.permissions.includes(activeTab));
  const canDeleteAction = currentUser?.role === 'admin' || (Array.isArray(currentUser?.permissions) && currentUser?.permissions.includes('CAN_DELETE'));

  const uniqueNoiRaSo = [...new Set(documents.map(d => d[5]).filter(val => val && val.trim() !== ''))];
  const uniqueNoiNhan = [...new Set(documents.map(d => d[6]).filter(val => val && val.trim() !== ''))];
  const uniqueNoiLuu = [...new Set(documents.map(d => d[7]).filter(val => val && val.trim() !== ''))];

  if (!isAppReady) return <div className="vh-100 d-flex justify-content-center align-items-center fw-bold text-primary">Đang kết nối đến máy chủ...</div>;

  if (!currentUser) {
    return (
      <div className="flex-grow-1 bg-light d-flex justify-content-center align-items-center vh-100">
        <form className="card p-4 shadow" onSubmit={handleLogin} style={{ width: '380px' }}>
          <h4 className="text-center mb-4 text-primary fw-bold">ĐĂNG NHẬP</h4>
          <input name="username" className="form-control mb-3" placeholder="Tài khoản" required />
          <input name="password" type="password" className="form-control mb-4" placeholder="Mật khẩu" required />
          <button className="btn btn-primary w-100 fw-bold shadow-sm py-2">Vào hệ thống</button>
        </form>
      </div>
    );
  }

  const filteredSearchDocs = searchTerm.trim() === '' 
    ? documents 
    : documents.filter(row => {
        const textToSearch = `${row[1] || ''} ${row[2] || ''} ${row[4] || ''} ${row[5] || ''} ${row[6] || ''} ${row[7] || ''} ${row[11] || ''}`.toLowerCase();
        return textToSearch.includes(searchTerm.trim().toLowerCase());
      });

  return (
    <div className="d-flex vh-100 position-relative">
      
      {/* SIDEBAR */}
      <div className="bg-dark text-white p-3 d-flex flex-column overflow-auto shadow" style={{ width: '280px', minWidth: '280px', zIndex: 10 }}>
        <h5 className="text-center mb-4 border-bottom pb-3">QUẢN LÝ HỒ SƠ</h5>
        
        {sidebarMode === 'main' ? (
          <>
            <p className="text-center text-warning small fw-bold">Tài khoản: {currentUser.username} ({currentUser.role})</p>
            <button className={`btn text-start mb-2 fw-bold ${activeTab === 'welcome' ? 'btn-primary' : 'btn-outline-light'}`} onClick={() => setActiveTab('welcome')}>🏠 Trang Chủ</button>
            <button className={`btn text-start mb-2 fw-bold ${activeTab.startsWith('vtf') ? 'btn-primary' : 'btn-outline-light'}`} onClick={() => { setSidebarMode('vtf'); setActiveTab('vtf_cv_di'); }}>1. VTF</button>
            <button className={`btn text-start mb-2 fw-bold ${activeTab.startsWith('htf') ? 'btn-primary' : 'btn-outline-light'}`} onClick={() => { setSidebarMode('htf'); setActiveTab('htf_cv_di'); }}>2. HTF</button>
            <button className={`btn text-start mb-2 fw-bold ${activeTab === 'luutru' ? 'btn-primary' : 'btn-outline-light'}`} onClick={() => {setSidebarMode('main'); setActiveTab('luutru'); setSearchTerm('');}}>3. Lưu Trữ</button>
            {currentUser.role === 'admin' && (
                <button className={`btn text-start mb-2 fw-bold ${activeTab === 'caidat' ? 'btn-primary' : 'btn-outline-light'}`} onClick={() => {setSidebarMode('main'); setActiveTab('caidat')}}>4. Cài Đặt</button>
            )}
            <button className="btn btn-danger mt-auto fw-bold shadow-sm" onClick={() => setCurrentUser(null)}>Đăng xuất</button>
          </>
        ) : (
          <>
            <h5 className="text-center mb-4 border-bottom pb-3 text-info">PHÂN HỆ {sidebarMode.toUpperCase()}</h5>
            <button className="btn btn-secondary mb-3 text-start fw-bold shadow-sm" onClick={() => {setSidebarMode('main'); setActiveTab('welcome');}}>← Quay lại Menu</button>
            {subMenus.map(m => <button key={m.id} className={`btn text-start mb-2 ${activeTab === sidebarMode+'_'+m.id ? 'btn-info text-dark fw-bold shadow-sm' : 'btn-outline-light'}`} onClick={() => setActiveTab(sidebarMode+'_'+m.id)}>{m.name}</button>)}
          </>
        )}
      </div>

      {/* MAIN CONTENT AREA */}
      <div className="p-3 flex-grow-1 bg-light overflow-auto">
        
        {/* TAB TRANG CHỦ */}
        {activeTab === 'welcome' && (
            <div className="h-100 d-flex flex-column align-items-center justify-content-center">
              <h1 className="text-primary mb-3 fw-bold">👋 Xin Chào, {currentUser.username}!</h1>
              <h5 className="text-secondary mb-4">Chào mừng bạn đến với Hệ thống Quản lý Hồ sơ</h5>
              <p className="text-muted text-center" style={{maxWidth: '600px'}}>
                Vui lòng chọn các phân hệ (VTF, HTF), tra cứu Lưu trữ hoặc truy cập Cài đặt ở thanh Menu bên trái để bắt đầu làm việc.
              </p>
            </div>
        )}

        {/* TAB LƯU TRỮ */}
        {activeTab === 'luutru' && (
            <div className="h-100 d-flex flex-column">
              <h3 className="text-primary mb-3 fw-bold">🗄️ Tủ Hồ Sơ Lưu Trữ (Global Search)</h3>
              <div className="mb-3 d-flex gap-2">
                <input type="text" className="form-control shadow-sm border-primary" placeholder="Nhập số công văn, nội dung, nơi nhận... để tìm kiếm" 
                        value={searchTerm} onChange={e => setSearchTerm(e.target.value)} />
              </div>
              <div className="table-responsive shadow-sm bg-white p-2 rounded flex-grow-1">
                <table className="table table-sm table-bordered table-striped table-hover align-middle text-center m-0" style={{ tableLayout: 'fixed', width: '100%', fontSize: '0.85rem' }}>
                  <thead className="table-dark">
                    <tr>
                      <th style={{ width: '8%' }}>Phân loại</th><th style={{ width: '4%' }}>Số</th><th style={{ width: '4%' }}>Sổ</th><th style={{ width: '7%' }}>Ngày</th><th style={{ width: '21%' }}>Nội Dung</th><th style={{ width: '8%' }}>Nơi Ra</th><th style={{ width: '8%' }}>Nơi Nhận</th><th style={{ width: '8%' }}>Nơi Lưu</th><th style={{ width: '8%' }}>File Gốc</th><th style={{ width: '8%' }}>File Word</th><th style={{ width: '8%' }}>PDF(Un)</th><th style={{ width: '8%' }}>Ghi Chú</th>
                    </tr>
                  </thead>
                  <tbody>
                    {filteredSearchDocs.length === 0 ? (
                      <tr><td colSpan="12" className="py-4 text-danger fw-bold">Không tìm thấy kết quả nào phù hợp với "{searchTerm}"</td></tr>
                    ) : (
                      filteredSearchDocs.map((row, i) => (
                        <tr key={i}>
                          <td className="fw-bold text-danger text-truncate">{allModules.find(m => m.id === row[12])?.name || row[12]}</td>
                          <td className="text-break">{row[1]}</td><td className="text-break">{row[2]}</td><td className="fw-medium">{row[3]}</td><td className="text-start text-break">{row[4]}</td><td className="text-break">{row[5]}</td><td className="text-break text-primary fw-medium">{row[6]}</td><td className="text-break text-success fw-medium">{row[7]}</td>
                          {/* NÂNG CẤP: Đã xử lý PDF(Un) ở mục 11 */}
                          <td>{renderFile(row[8], true)}</td><td>{renderFile(row[9], false)}</td><td>{renderFile(row[10], true)}</td><td className="text-break">{row[11]}</td>
                        </tr>
                      ))
                    )}
                  </tbody>
                </table>
              </div>
            </div>
        )}

        {/* TAB CÀI ĐẶT */}
        {activeTab === 'caidat' && (
            <div className="h-100 d-flex flex-column">
              <h3 className="text-secondary mb-3 fw-bold">⚙️ Cài Đặt Tài Khoản</h3>
              <div className="mb-3 d-flex align-items-center">
                <button className="btn btn-primary me-2 fw-bold shadow-sm" onClick={() => { setEditingUser(null); setUserFormData({username:'',password:'',role:'user',permissions:[]}); setShowUserForm(true); }}>+ Thêm Nhân viên</button>
                <button className="btn btn-success me-3 fw-bold shadow-sm" onClick={loadData} disabled={loading}>{loading ? 'Đang tải...' : 'Làm mới'}</button>
                {saving && <span className="text-primary fw-bold px-3 py-1 bg-white rounded shadow-sm border border-primary">⏳ Đang xử lý...</span>}
              </div>
              <div className="table-responsive shadow-sm bg-white p-2 rounded">
                <table className="table table-bordered table-striped table-hover align-middle text-center m-0">
                  <thead className="table-dark">
                    <tr><th style={{width:'5%'}}>STT</th><th style={{width:'15%'}}>Tài khoản</th><th style={{width:'15%'}}>Mật khẩu</th><th style={{width:'10%'}}>Chức vụ</th><th style={{width:'45%'}}>Phân quyền chỉnh sửa / xóa</th><th style={{width:'10%'}}>Thao tác</th></tr>
                  </thead>
                  <tbody>
                    {users.map((u, i) => (
                      <tr key={i}>
                        <td className="fw-bold">{i+1}</td>
                        <td className="fw-bold text-primary">{u.username}</td>
                        <td>{u.password}</td>
                        <td><span className={`badge ${u.role === 'admin' ? 'bg-danger' : 'bg-info text-dark'}`}>{u.role.toUpperCase()}</span></td>
                        <td className="text-start">
                            {u.role === 'admin' ? <span className="text-success fw-bold">Toàn quyền hệ thống</span> : (
                              <>
                                {u.permissions.includes('CAN_DELETE') && <span className="badge bg-danger me-2 mb-1">CÓ QUYỀN XÓA</span>}
                                {u.permissions.filter(p => p !== 'CAN_DELETE').length === 0 
                                  ? <span className="text-muted">Chỉ được Xem</span> 
                                  : u.permissions.filter(p => p !== 'CAN_DELETE').map(p => <span key={p} className="badge bg-secondary me-1 mb-1">{allModules.find(m=>m.id === p)?.name}</span>)
                                }
                              </>
                            )}
                        </td>
                        <td>
                          {u.role !== 'admin' && (
                              <div className="d-flex justify-content-center gap-1">
                                <button className="btn btn-warning btn-sm p-1" onClick={() => { setEditingUser(u); setUserFormData({username:u.username, password:u.password, role:u.role, permissions:u.permissions}); setShowUserForm(true); }}>Sửa</button>
                                <button className="btn btn-danger btn-sm p-1" onClick={() => handleDeleteUser(u)}>Xóa</button>
                              </div>
                          )}
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            </div>
        )}

        {/* TAB VĂN BẢN (VTF / HTF) */}
        {(activeTab !== 'welcome' && activeTab !== 'luutru' && activeTab !== 'caidat') && (
          <>
            <h3 className="text-primary mb-3 fw-bold">{(activeTab.startsWith('vtf') ? 'VTF' : 'HTF')} - {subMenus.find(m => m.id === activeTab.split('_').slice(1).join('_'))?.name}</h3>
            
            <div className="mb-3 d-flex align-items-center">
              {canModify && <button className="btn btn-primary me-2 fw-bold shadow-sm" disabled={saving || loading} onClick={() => { setEditingRow(null); setRetainedFiles({ goc: [], word: [], pdfUn: [] }); setFormData({choso:'',vaoso:'',ngay:getToday(),noiras:'',noinhan:'',noiluu:'',noidung:'',ghichu:''}); setShowAddForm(true); }}>Thêm mới</button>}
              <button className="btn btn-success me-3 fw-bold shadow-sm" onClick={loadData} disabled={saving || loading}>{loading ? 'Đang tải...' : 'Làm mới'}</button>
              {saving && <span className="text-danger fw-bold px-3 py-1 bg-white rounded shadow-sm border border-danger">🚀 Đang tải file lên Drive...</span>}
            </div>

            <div className="table-responsive shadow-sm bg-white p-2 rounded">
              <table className="table table-sm table-bordered table-striped table-hover align-middle text-center m-0" style={{ tableLayout: 'fixed', width: '100%', fontSize: '0.85rem' }}>
                <thead className="table-dark">
                  <tr>
                    <th style={{ width: '3%' }}>STT</th><th style={{ width: '4%' }}>Số</th><th style={{ width: '4%' }}>Sổ</th><th style={{ width: '7%' }}>Ngày</th><th style={{ width: '20%' }}>Nội Dung</th><th style={{ width: '7%' }}>Nơi Ra</th><th style={{ width: '7%' }}>Nơi Nhận</th><th style={{ width: '7%' }}>Nơi Lưu</th><th style={{ width: '8%' }}>File Gốc</th><th style={{ width: '8%' }}>File Word</th><th style={{ width: '8%' }}>PDF(Un)</th><th style={{ width: '6%' }}>Ghi Chú</th>
                    {canModify && <th style={{ width: '11%' }}>Thao tác</th>}
                  </tr>
                </thead>
                <tbody>
                  {documents.filter(r => r[12] === activeTab).length === 0 ? (
                    <tr><td colSpan={canModify ? 13 : 12} className="py-4 text-muted fw-bold">Chưa có dữ liệu</td></tr>
                  ) : (
                    documents.filter(r => r[12] === activeTab).map((row, i) => (
                      <tr key={i}>
                        <td className="fw-bold">{i + 1}</td>
                        <td className="text-break">{row[1]}</td><td className="text-break">{row[2]}</td><td className="fw-medium">{row[3]}</td><td className="text-start text-break">{row[4]}</td><td className="text-break">{row[5]}</td><td className="text-break text-primary fw-medium">{row[6]}</td><td className="text-break text-success fw-medium">{row[7]}</td>
                        {/* NÂNG CẤP: Đã xử lý hiển thị đa file */}
                        <td>{renderFile(row[8], true)}</td><td>{renderFile(row[9], false)}</td><td>{renderFile(row[10], true)}</td><td className="text-break">{row[11]}</td>
                        {canModify && (
                          <td>
                            <div className="d-flex justify-content-center gap-1">
                              <button className="btn btn-warning btn-sm py-0 px-2 shadow-sm fw-bold" disabled={saving} onClick={() => { 
                                setEditingRow(row); 
                                setRetainedFiles({ goc: parseFiles(row[8]), word: parseFiles(row[9]), pdfUn: parseFiles(row[10]) }); 
                                setFormData({choso:row[1],vaoso:row[2],ngay:row[3],noidung:row[4],noiras:row[5],noinhan:row[6],noiluu:row[7],ghichu:row[11]}); 
                                setShowAddForm(true); 
                              }}>Sửa</button>
                              
                              {canDeleteAction && (
                                <button className="btn btn-danger btn-sm py-0 px-2 shadow-sm fw-bold" disabled={saving} onClick={() => handleDeleteDoc(row)}>Xóa</button>
                              )}
                            </div>
                          </td>
                        )}
                      </tr>
                    ))
                  )}
                </tbody>
              </table>
            </div>
          </>
        )}
      </div>

      {/* ============ MODAL THÊM/SỬA VĂN BẢN ============ */}
      {showAddForm && (
        <div className="modal d-block" style={{ backgroundColor: 'rgba(0,0,0,0.6)', overflowY: 'auto' }}>
          <div className="modal-dialog modal-xl modal-dialog-centered my-5">
            <div className="modal-content border-0 shadow-lg">
              <div className="modal-header bg-primary text-white">
                <h5 className="modal-title fw-bold">{editingRow ? 'CẬP NHẬT VĂN BẢN' : 'THÊM MỚI VĂN BẢN'}</h5>
                <button type="button" className="btn-close btn-close-white" onClick={() => setShowAddForm(false)}></button>
              </div>
              <div className="modal-body p-4 bg-light">
                
                <datalist id="list-noiras">{uniqueNoiRaSo.map((val, idx) => <option key={idx} value={val} />)}</datalist>
                <datalist id="list-noinhan">{uniqueNoiNhan.map((val, idx) => <option key={idx} value={val} />)}</datalist>
                <datalist id="list-noiluu">{uniqueNoiLuu.map((val, idx) => <option key={idx} value={val} />)}</datalist>

                <div className="row g-3 bg-white p-3 rounded shadow-sm">
                  <div className="col-md-3"><label className="fw-bold small text-primary">1. Cho Số</label>
                    <input type="text" className="form-control bg-light" value={formData.choso} onChange={e => setFormData({...formData, choso: e.target.value})} />
                  </div>
                  <div className="col-md-3"><label className="fw-bold small text-primary">2. Vào Sổ</label>
                    <input type="text" className="form-control bg-light" value={formData.vaoso} onChange={e => setFormData({...formData, vaoso: e.target.value})} />
                  </div>
                  <div className="col-md-3"><label className="fw-bold small text-primary">3. Ngày Ra Số (Tự động)</label>
                    <input type="date" className="form-control bg-light" value={formData.ngay} onChange={e => setFormData({...formData, ngay: e.target.value})} />
                  </div>
                  <div className="col-md-3"><label className="fw-bold small text-primary">4. Ghi chú</label>
                    <input type="text" className="form-control bg-light" value={formData.ghichu} onChange={e => setFormData({...formData, ghichu: e.target.value})} />
                  </div>

                  <div className="col-md-4"><label className="fw-bold small text-info">5. Nơi Ra Số</label>
                    <input list="list-noiras" type="text" className="form-control bg-light border-info" value={formData.noiras} onChange={e => setFormData({...formData, noiras: e.target.value})} placeholder="Chọn hoặc nhập mới..." />
                  </div>
                  <div className="col-md-4"><label className="fw-bold small text-info">6. Nơi Nhận</label>
                    <input list="list-noinhan" type="text" className="form-control bg-light border-info" value={formData.noinhan} onChange={e => setFormData({...formData, noinhan: e.target.value})} placeholder="Chọn hoặc nhập mới..." />
                  </div>
                  <div className="col-md-4"><label className="fw-bold small text-info">7. Nơi Lưu</label>
                    <input list="list-noiluu" type="text" className="form-control bg-light border-info" value={formData.noiluu} onChange={e => setFormData({...formData, noiluu: e.target.value})} placeholder="Chọn hoặc nhập mới..." />
                  </div>

                  <div className="col-12"><label className="fw-bold small text-primary">8. Nội Dung / Trích yếu</label>
                    <textarea className="form-control bg-light" rows="3" value={formData.noidung} onChange={e => setFormData({...formData, noidung: e.target.value})}></textarea>
                  </div>
                  
                  {/* CỘT 9: FILE GỐC (Hỗ trợ upload nhiều file) */}
                  <div className="col-md-4 mt-4">
                    <label className="fw-bold small text-danger">9. File Gốc (PDF/Ảnh) - Chọn nhiều tệp</label>
                    {retainedFiles.goc.map((f, idx) => (
                      <div key={idx} className="d-flex align-items-center bg-white border border-danger p-1 rounded mt-1 shadow-sm">
                        <a href={f.url} target="_blank" rel="noreferrer" className="text-truncate me-auto ms-2 text-decoration-none small fw-medium text-danger" title={f.name}>📄 {f.name}</a>
                        <button type="button" className="btn btn-sm btn-danger py-0 px-2 fw-bold" onClick={() => setRetainedFiles({...retainedFiles, goc: retainedFiles.goc.filter((_, i) => i !== idx)})} title="Xóa file cũ này">✕</button>
                      </div>
                    ))}
                    <input id="add_file_goc" type="file" multiple className="form-control border-danger bg-light mt-1" accept=".pdf, image/*" />
                  </div>

                  {/* CỘT 10: FILE WORD (Hỗ trợ upload nhiều file) */}
                  <div className="col-md-4 mt-4">
                    <label className="fw-bold small text-success">10. File Word - Chọn nhiều tệp</label>
                    {retainedFiles.word.map((f, idx) => (
                      <div key={idx} className="d-flex align-items-center bg-white border border-success p-1 rounded mt-1 shadow-sm">
                        <a href={f.url} target="_blank" rel="noreferrer" className="text-truncate me-auto ms-2 text-decoration-none small fw-medium text-success" title={f.name}>📝 {f.name}</a>
                        <button type="button" className="btn btn-sm btn-success py-0 px-2 fw-bold" onClick={() => setRetainedFiles({...retainedFiles, word: retainedFiles.word.filter((_, i) => i !== idx)})} title="Xóa file cũ này">✕</button>
                      </div>
                    ))}
                    <input id="add_file_word" type="file" multiple className="form-control border-success bg-light mt-1" accept=".doc, .docx" />
                  </div>

                  {/* CỘT 11: FILE PDF (Hỗ trợ upload nhiều file) */}
                  <div className="col-md-4 mt-4">
                    <label className="fw-bold small text-primary">11. PDF (Chưa đóng dấu) - Chọn nhiều tệp</label>
                    {retainedFiles.pdfUn.map((f, idx) => (
                      <div key={idx} className="d-flex align-items-center bg-white border border-primary p-1 rounded mt-1 shadow-sm">
                        <a href={f.url} target="_blank" rel="noreferrer" className="text-truncate me-auto ms-2 text-decoration-none small fw-medium text-primary" title={f.name}>📑 {f.name}</a>
                        <button type="button" className="btn btn-sm btn-primary py-0 px-2 fw-bold" onClick={() => setRetainedFiles({...retainedFiles, pdfUn: retainedFiles.pdfUn.filter((_, i) => i !== idx)})} title="Xóa file cũ này">✕</button>
                      </div>
                    ))}
                    <input id="add_file_pdf_un" type="file" multiple className="form-control border-primary bg-light mt-1" accept=".pdf" />
                  </div>

                </div>
              </div>
              <div className="modal-footer bg-white border-top-0">
                <button className="btn btn-secondary px-4 fw-bold" onClick={() => setShowAddForm(false)}>Hủy</button>
                <button className="btn btn-primary px-4 fw-bold shadow-sm" onClick={handleSaveDoc}>Lưu dữ liệu</button>
              </div>
            </div>
          </div>
        </div>
      )}

      {/* ============ MODAL THÊM/SỬA NHÂN VIÊN ============ */}
      {showUserForm && (
        <div className="modal d-block" style={{ backgroundColor: 'rgba(0,0,0,0.6)', overflowY: 'auto' }}>
          <div className="modal-dialog modal-lg modal-dialog-centered my-5">
            <div className="modal-content border-0 shadow-lg">
              <div className="modal-header bg-secondary text-white">
                <h5 className="modal-title fw-bold">{editingUser ? 'SỬA TÀI KHOẢN' : 'TẠO TÀI KHOẢN MỚI'}</h5>
                <button type="button" className="btn-close btn-close-white" onClick={() => setShowUserForm(false)}></button>
              </div>
              <div className="modal-body p-4 bg-light">
                <div className="row g-3 bg-white p-3 rounded shadow-sm mb-3">
                   <div className="col-md-6"><label className="fw-bold small">Tài khoản</label><input className="form-control bg-light" value={userFormData.username} onChange={e => setUserFormData({...userFormData, username: e.target.value})} disabled={editingUser} /></div>
                   <div className="col-md-6"><label className="fw-bold small">Mật khẩu</label><input className="form-control bg-light" value={userFormData.password} onChange={e => setUserFormData({...userFormData, password: e.target.value})} /></div>
                </div>

                <div className="mb-3 mt-4 p-3 bg-white border border-danger rounded shadow-sm">
                  <div className="form-check form-switch d-flex align-items-center">
                    <input className="form-check-input me-2 mt-0" type="checkbox" id="chk_delete" style={{transform: 'scale(1.2)'}}
                      checked={userFormData.permissions.includes('CAN_DELETE')}
                      onChange={(e) => {
                         const newPerms = e.target.checked 
                            ? [...userFormData.permissions, 'CAN_DELETE'] 
                            : userFormData.permissions.filter(p => p !== 'CAN_DELETE');
                         setUserFormData({...userFormData, permissions: newPerms});
                      }} 
                    />
                    <label className="form-check-label fw-bold text-danger" htmlFor="chk_delete">Cấp quyền XÓA văn bản (Nếu tắt công tắc này, nhân viên chỉ có thể Thêm và Sửa)</label>
                  </div>
                </div>

                <h6 className="text-primary fw-bold mb-2">Tích chọn quyền CHỈNH SỬA trên các bảng:</h6>
                <p className="small text-muted mb-3">* Nếu không được tích, nhân viên chỉ có thể XEM tài liệu ở danh mục đó.</p>
                <div className="row g-2 bg-white p-3 rounded shadow-sm border">
                   {allModules.map(mod => (
                     <div className="col-md-4 col-sm-6" key={mod.id}>
                        <div className="form-check form-switch">
                          <input className="form-check-input" type="checkbox" id={`chk_${mod.id}`}
                            checked={userFormData.permissions.includes(mod.id)}
                            onChange={(e) => {
                               const newPerms = e.target.checked 
                                  ? [...userFormData.permissions, mod.id] 
                                  : userFormData.permissions.filter(p => p !== mod.id);
                               setUserFormData({...userFormData, permissions: newPerms});
                            }} 
                          />
                          <label className="form-check-label" htmlFor={`chk_${mod.id}`}>{mod.name}</label>
                        </div>
                     </div>
                   ))}
                </div>
              </div>
              <div className="modal-footer bg-white border-top-0">
                <button className="btn btn-secondary px-4 fw-bold" onClick={() => setShowUserForm(false)}>Hủy</button>
                <button className="btn btn-primary px-4 fw-bold shadow-sm" onClick={handleSaveUser} disabled={saving}>{saving ? 'Đang lưu...' : 'Lưu tài khoản'}</button>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}
